import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

const PaymentCancel = () => {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-2xl shadow-2xl p-8 text-center border-2 border-slate-200">
          <div className="w-20 h-20 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <XCircle className="w-12 h-12 text-slate-600" />
          </div>
          
          <h1 className="text-3xl font-bold text-slate-900 mb-3">
            Betaling avbrutt
          </h1>
          
          <p className="text-slate-600 mb-8">
            Du avbrøt betalingsprosessen. Ingen beløp er trukket.
          </p>
          
          <div className="space-y-3">
            <Button
              onClick={() => navigate('/lexy')}
              className="w-full bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-700 hover:to-blue-700"
              size="lg"
            >
              <ArrowLeft className="w-5 h-5 mr-2" />
              Tilbake til Lexy
            </Button>
            
            <p className="text-sm text-slate-500">
              Du kan oppgradere når som helst fra innstillingene
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
